import 'whatwg-fetch';

export async function getData() {

  function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      var error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }

  function parseJSON(response) {
    return response.json();
  }

  return fetch('http://www.dszuqiu.com/m/ajax/score?randID=' + Math.random())
    .then(checkStatus)
    .then(parseJSON)
    .then(function(json){
      //console.log('score.js: ' + json.races[0].league);
      return json;
    })
    .catch(function(error) {
      console.log('request failed', error)
  });

}



/** WEBPACK FOOTER **
 ** ./src/services/score.js
 **/